import React, { useState } from 'react'
import { useMutation } from 'react-apollo-hooks'
import { navigate } from '@reach/router'
import { Text } from 'rebass'
import Modal from 'styled-react-modal'

import Card from '../Card'
import Section from '../Section'
import Button from '../Button'

import mutations from '../../mutations'
import routes from '../../constants/routes'

const DangerZone = ({ id }) => {
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const [submitting, setSubmitting] = useState(false)
  const [modal, setModal] = useState(false)
  const deleteReward = useMutation(mutations.rewards.DELETE)

  const onSubmit = async () => {
    setSubmitting(true)
    setSuccess(null)
    setError(null)

    try {
      await deleteReward({ variables: { id } })
      setSuccess('Reward was successfully deleted')
      setTimeout(() => {
        // replace route so user cannot navigate back
        navigate(routes.REWARDS_ROOT, { replace: true })
      }, 1000)
    } catch (e) {
      setError(e.message)
      setSubmitting(false)
    }
  }

  const toggleModal = () => {
    if (submitting) return
    setSuccess(null)
    setError(null)
    setModal(!modal)
  }

  return (
    <Section
      heading="Danger Zone"
      text="Irreversible and destructive actions. Tread lightly."
    >
      <Card
        heading="Delete Reward"
        text="Once you delete a reward, there is no going back."
      >
        <Modal
          isOpen={modal}
          onBackgroundClick={toggleModal}
          onEscapeKeydown={toggleModal}
        >
          <Card
            heading="Confirm Deletion"
            text="If you are not sure then you should deactivate this reward instead. Are you sure you want to delete?"
          >
            <Button outline mr={3} disabled={submitting} onClick={toggleModal}>Keep this Reward</Button>
            <Button color="error" disabled={submitting} mt={[3, 0]} onClick={onSubmit}>Delete this Reward</Button>
            {error && <Text color="error" mt={3}>{error}</Text>}
            {success && <Text color="success" mt={3}>{success}</Text>}
          </Card>
        </Modal>
        <Button color="error" onClick={toggleModal}>Delete this Reward</Button>
      </Card>
    </Section>
  )
}

export default DangerZone
